import { MapContentLayer } from '../MapContentLayer';
import { CircleLayerSpecification, FilterSpecification, LayerSpecification, Map } from 'maplibre-gl';
import { MapContentSource } from '../MapContentSource';

export class ObservationShadowLayer extends MapContentLayer {

  constructor(
    source: MapContentSource
  ) {
    super('observation-shadow-layer', source);
  }

  toLayerSpecification(): LayerSpecification {
    return {
      id: this.layerId,
      type: 'circle',
      source: this.sourceRef.sourceId,
      paint: {
        'circle-radius': 15,
        'circle-color': '#000',
        'circle-blur': 0.75,
        'circle-translate': [2, 2],
      },
    } as CircleLayerSpecification;
  }

  filterByTime(map: Map, timeFrom: number, timeTo: number) {
    const filter: any[] = ['all'];
    if (!!timeFrom) {
      filter.push(['>=', ['get', 'time'], timeFrom]);
    }
    if (!!timeTo) {
      filter.push(['<=', ['get', 'time'], timeTo]);
    }

    map.setFilter(
      this.layerId,
      filter as FilterSpecification,
    );
  }
}
